export const GENERAL_APPLICATION_VALUE = 'general-application';

export const contactFields = [
  { name: 'firstName', label: 'First name', type: 'text', required: true, placeholder: '' },
  { name: 'lastName', label: 'Last name', type: 'text', required: true, placeholder: '' },
  { name: 'email', label: 'Email', type: 'email', required: true, placeholder: '' },
  { name: 'companyName', label: 'Company', type: 'text', required: true, placeholder: '' },
  {
    name: 'message',
    label: 'Message',
    type: 'textarea',
    required: true,
    placeholder: 'What are you trying to automate or validate?',
  },
];

export const demoFields = [
  { name: 'firstName', label: 'First name', type: 'text', required: true, placeholder: '' },
  { name: 'lastName', label: 'Last name', type: 'text', required: true, placeholder: '' },
  { name: 'email', label: 'Email', type: 'email', required: true, placeholder: '' },
  { name: 'companyName', label: 'Company', type: 'text', required: true, placeholder: '' },
  {
    name: 'message',
    label: 'What are you looking to automate?',
    type: 'textarea',
    required: false,
    placeholder: '',
  },
];

export function createRoleOptions(jobs = [], selectedRole = GENERAL_APPLICATION_VALUE) {
  const options = [
    { value: GENERAL_APPLICATION_VALUE, label: 'General application' },
    ...jobs.map((job) => ({ value: job.title, label: job.title })),
  ];

  if (selectedRole && !options.some((option) => option.value === selectedRole)) {
    options.splice(1, 0, { value: selectedRole, label: selectedRole });
  }

  return options;
}

export function createApplicationFields(selectedRole = GENERAL_APPLICATION_VALUE) {
  return [
    { name: 'role', label: 'Role', type: 'select', required: true, defaultValue: selectedRole },
    { name: 'firstName', label: 'First name', type: 'text', required: true, placeholder: '' },
    { name: 'lastName', label: 'Last name', type: 'text', required: true, placeholder: '' },
    { name: 'email', label: 'Email', type: 'email', required: true, placeholder: '' },
    {
      name: 'linkedInOrPortfolio',
      label: 'LinkedIn or portfolio',
      type: 'text',
      required: false,
      placeholder: 'Optional URL',
    },
    {
      name: 'message',
      label: 'Why Rivelin?',
      type: 'textarea',
      required: false,
      placeholder: 'Tell us what draws you to the company or role.',
    },
    { name: 'cv', label: 'Upload CV', type: 'file', required: true, accept: '.pdf,.doc,.docx' },
  ];
}
